<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" @click:outside="$emit('updateDialog', false)" max-width="800px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" class="mb-5" dark v-on="on" @click="$emit('updateDialog', true)">{{ button_name }}</v-btn>
      </template>

      <v-card>
        <v-form v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text>
            <!-- START FORM DIALOG -->
            <div class="row">
              <div class="col-md-12">
                <v-text-field data-vv-as="nombre" label="Nombre*" name="name" v-model="item.name" v-validate="'required'" :disabled="isViewModal()"></v-text-field>
                <span class="red--text">{{ errors.first("name") }}</span>

                <v-alert v-if="mappingError" type="warning" dense class="mt-3 mb-3">
                  {{ mappingError }}
                </v-alert>

                <div class="mt-3">
                  <p class="subtitle-2 mb-2">Mapeo automático de estado:</p>
                  <p class="caption grey--text mb-3">Selecciona una opción. Este estado se asignará automáticamente cuando la orden cambie al estado correspondiente.</p>
                  
                  <v-radio-group v-model="selectedMapping" :disabled="isViewModal()" @change="updateMapping" row>
                    <v-radio 
                      label="Mapear a estado Pendiente" 
                      value="map_pending"
                      color="orange"
                    ></v-radio>

                    <v-radio 
                      label="Mapear a estado En Ejecución" 
                      value="map_execution"
                      color="blue"
                    ></v-radio>

                    <v-radio 
                      label="Mapear a estado Cancelado" 
                      value="map_cancelled"
                      color="red"
                    ></v-radio>

                    <v-radio 
                      label="Mapear a estado Finalizado" 
                      value="map_finished"
                      color="green"
                    ></v-radio>

                    <v-radio 
                      label="Sin mapeo" 
                      value="none"
                      color="grey"
                    ></v-radio>
                  </v-radio-group>
                </div>
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" text type="submit" v-if="!isViewModal()" :loading="loading">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";

export default {
  mixins: [ModalGenericMixin],
  props: {
    parent: Object,
    service: Object,
    modal_title: String,
    dialog: Boolean,
    item: Object,
    button_name: String,
    formBtn: String,
  },
  data() {
    return {
      show: false,
      mappingError: null,
      selectedMapping: 'none',
    };
  },
  computed: {
    mappingValue() {
      if (this.item.map_pending) return 'map_pending';
      if (this.item.map_execution) return 'map_execution';
      if (this.item.map_cancelled) return 'map_cancelled';
      if (this.item.map_finished) return 'map_finished';
      return 'none';
    }
  },
  watch: {
    item() {
      this.$emit("updateItem", this.item);
      this.selectedMapping = this.mappingValue;
    },
    dialog() {
      this.errors.clear();
      if (this.dialog) {
        this.selectedMapping = this.mappingValue;
      }
    },
  },
  mounted() {},
  methods: {
    isViewModal() {
      return this.formBtn == "";
    },
    updateMapping(value) {
      this.mappingError = null;
      
      // Resetear todos los campos
      this.item.map_pending = false;
      this.item.map_execution = false;
      this.item.map_cancelled = false;
      this.item.map_finished = false;
      
      // Activar el campo seleccionado
      if (value !== 'none') {
        this.item[value] = true;
      }
    },
    createItem(e) {
      if (this.loading) return;
      this.$validator.validate().then((valid) => {
        if (valid) {
          e.preventDefault();

          this.loading = true;
          const data = {
            id: this.item.id,
            name: this.item.name,
            map_pending: this.item.map_pending || false,
            map_execution: this.item.map_execution || false,
            map_cancelled: this.item.map_cancelled || false,
            map_finished: this.item.map_finished || false,
          };

          if (this.item.id > 0) {
            this.service
              .update(data)
              .then((response) => {
                if (response.status == true) {
                  this.$toast.success("La " + this.modal_title + " se modificó correctamente.", "OK");
                  this.$emit("updateDialog", false);
                  this.$emit("loadList");
                } else {
                  if (Object.prototype.hasOwnProperty.call(response, "message")) {
                    this.$toast.error(response.message, "Error");
                  } else {
                    this.$toast.error(response.msg, "Error");
                  }
                }
                this.loading = false;
              })
              .catch((error) => {
                console.error(error);
                this.loading = false;
              });
          } else {
            this.service
              .create(data)
              .then((response) => {
                if (response.status == true) {
                  this.$toast.success("La " + this.modal_title + " se creó correctamente.", "OK");
                  this.$emit("updateDialog", false);
                  this.$emit("loadList");
                } else {
                  if (Object.prototype.hasOwnProperty.call(response, "message")) {
                    this.$toast.error(response.message, "Error");
                  } else {
                    this.$toast.error(response.msg, "Error");
                  }
                }
                this.loading = false;
              })
              .catch((error) => {
                console.error(error);
                this.loading = false;
              });
          }
        }
      });
    },
  },
};
</script>
